import React, { createContext, useContext } from "react";
import { chatStreamManager } from "../streaming/ChatStreamManager";

const ChatStreamContext = createContext(chatStreamManager);

export const ChatStreamProvider = ({ children }) => {
  return (
    <ChatStreamContext.Provider value={chatStreamManager}>
      {children}
    </ChatStreamContext.Provider>
  );
};

export const useChatStreamManager = () => {
  return useContext(ChatStreamContext);
};

